const DocumentStatus = {
    TO_SIGN: 'TO_SIGN',
    WAITING: 'WAITING',
    SIGNED: 'SIGNED',
};

module.exports = DocumentStatus;